<template>
    <aside class="login-aside" style="background-image: url('/img/bg/purple-bg-main.png')">
        <h1 class="text-white font-weight-normal font-40">
            <b>NEVER</b> ENTER AN ORDER, <br>
            INVOICE OR CREDIT <b>EVER AGAIN</b>
        </h1>

        <div class="mt-5">
            <img src="/auth/invoice-upload.png" class="invoice-upload-img">
        </div>

        <div class="row justify-content-center mx-0 mt-5">
            <div class="col-xl-7 col-lg-9 col-md-10 col text-white text-left">
                <ul class="login-bullets">
                    <li>Full extraction</li>
                    <li>Detect duplicate invoices and price changes</li>
                    <li>Integrates with your favourite inventory and accounting tools</li>
                    <li>Match and fulfil existing purchase orders or create a new one</li>
                </ul>
            </div>
        </div>
    </aside>
</template>

<script>
export default {
    name: 'AuthAside'
}
</script>

<style lang="scss" scoped>
.login-aside {
    flex: 1 0 0;
    width: 100%;
    height: 100%;
    min-height: 100vh;
    background-size: cover;
    padding: 80px 10px 70px;
    text-align: center;
}

.invoice-upload-img {
    height: 360px;
}

ul {
    list-style: none;
    padding-left: 0;
    font-size: 17px;
    margin-left: 0px;
    line-height: 28px;
}

li {
    /*padding-left: 1em;*/
    /*text-indent: -1em;*/
}

li:before {
    /*content: "\2713";*/
    display: inline-block;
    padding-right: 5px;
    vertical-align: middle;
    font-weight: 900;
}

@include media-breakpoint-only(md) {
    .invoice-upload-img {
        height: 220px;
    }
}

@include media-breakpoint-down(sm) {
    .login-aside {
        display: none;
    }
}
</style>
